import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Report from "../../component/report/report.js";

import {getBase64} from '../../utils/tools';

class Reportcon extends React.Component{
  constructor(props) {
    super(props);

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileRemove = this.handleFileRemove.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleTreeChange = this.handleTreeChange.bind(this);
    this.downloadReport = this.downloadReport.bind(this);

    this.state = {
        formData: {
            path: "",
            position: 0
        },
        downloaded: false,
        downloading: false,
        submitted: false,
        dataLoaded: false
    };

  }

  componentWillReceiveProps(nextProps) {
    /* Si le paramètre de l'url a changé alors on charge le nouveau rapport */
    if (nextProps.match.params.id !== this.props.match.params.id) {
      /* import le rapport */
      this.props.getReportByIdAction(nextProps.match.params.id, this.props.reports)
    }
  }

  componentWillMount() {
      /* import le rapport */
      this.props.getReportByIdAction(this.props.match.params.id, this.props.reports, true).then(res => {
          this.setState({dataLoaded: true})
      })

  }

  handleFileChange(event) {
    const target = event.target;
    if(target.files[0].type === "application/pdf" || target.files[0].type === "image/jpg" || target.files[0].type === "image/jpeg" || target.files[0].type=== "image/png") {
      getBase64(target.files[0]).then(res => {
        let formData = Object.assign({}, this.state.formData);
        formData[target.name] = res;
        formData.title = target.files[0].name;
        this.setState({formData: formData}, () =>
          this.handleFormSubmit()
        );
      });
    } else {
      this.props.displaySnackbar("error", "Format non pris en charge");
    }
  }

  handleFileRemove(id, type) {
    let report = this.props.reports.find(report => report.id === parseInt(this.props.match.params.id, 10));
    if(type && type === "survey"){
        var survey = report.surveys.find(d => parseInt(d.id, 10) === parseInt(id, 10));
        if(survey){
            this.props.removeSurveyAction(survey.id).then(res => {
                /* import le rapport */
                this.props.getReportByIdAction(report.id, this.props.reports, true)
            })
        }
        this.props.closeConfirmation();
    }else{
      var document = report.documents.find(d => parseInt(d.id, 10) === parseInt(id, 10));
      this.props.removeDocumentAction(report,document.id)
      this.props.closeConfirmation();
    }
  }

  handleTreeChange(tree) {
    for (var i = 0; i < tree.length; i++) {
      let branch = tree[i]

      // Compare l'ancienne et la nouvelle position
      if (branch.position !== i) {
        let report = this.props.reports.find(report => report.id === parseInt(this.props.match.params.id, 10));
        if(branch.filename){
            let document = report.documents.find(document => document.id === branch.id);
            if(document){
                document.position = i;
                this.props.updateReportDocumentAction(
                    report,
                    branch.id,
                    document,
                    {position: document.position}
                )
            }
        }else{
            let survey = report.surveys.find(survey => survey.id === branch.id);
            if(survey){
                survey.position = i;
                this.props.updateReportSurveyAction(
                    report,
                    branch.id,
                    survey,
                    {position: survey.position}
                )
            }
        }
      }
    }
  }

  handleFormSubmit(){
    this.setState({ submitted: true }, () => {
      let report = this.props.reports.find(report => report.id === parseInt(this.props.match.params.id, 10))
      let formData = Object.assign({}, this.state.formData);
      formData.report = parseInt(this.props.match.params.id, 10);
      formData.position = report.documents.length
      this.props.createDocumentAction(formData).then(res => {
          this.setState({
            submitted: false
          })
      }).catch(err => {
        this.setState({
          submitted: false
        })
      })
    })
  }

  downloadReport(id) {
    this.setState({ downloading: true, downloaded: false }, () => {
        var report = this.props.reports.find(report => report.id === parseInt(this.props.match.params.id, 10));
      this.props.downloadReportByIdAction(
          id,
          report,
          report.audit.company.reference + "_FICHE_" + report.audit.lot + "_" + report.audit.reference + "_" + report.audit.company.reference + "_EETI_" + report.audit.company.department
       )
      .then(res => {
        this.setState({ downloading: false, downloaded: true })
      })
    })
  }

  render(){
    let report = this.props.reports.find(report => report.id === parseInt(this.props.match.params.id, 10))
    return <Report
      user={this.props.user}
      report={report ? report : {}}
      handleFileChange={this.handleFileChange}
      handleFileRemove={this.handleFileRemove}
      displayConfirmation={this.props.displayConfirmation}
      formData={this.state.formData}
      submitted={this.state.submitted}
      handleTreeChange={this.handleTreeChange}
      downloadReport={this.downloadReport}
      downloading={this.state.downloading}
      downloaded={this.state.downloaded}
      dataLoaded={this.state.dataLoaded}
    ></Report>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Reportcon);



// WEBPACK FOOTER //
// ./src/container/report/report-container.js